module.exports = {"130533100":"洺州镇","130533101":"梨园屯镇","130533102":"章台镇","130533103":"侯贯镇","130533104":"七级镇","130533105":"贺营镇","130533106":"方家营镇","130533107":"常庄镇","130533108":"第什营镇","130533109":"贺钊镇","130533110":"赵村镇","130533202":"枣园乡","130533203":"固献乡","130533206":"张家营乡","130533207":"常屯乡","130533209":"高公庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130533.json
// module id = 146
// module chunks = 0